import { create } from "zustand";
import { fetchLogin } from "./Services/fetchlogin";
import { fetchRegister } from "./Services/fetchCreateUsers";
import { fetchRestaurantRegister } from "./Services/restaurantFetch";
import { fetchRestaurants } from "./Constants/getRestaurants";
import { fetchRestaurantDetail } from "./Constants/restaurantDetailFetch";
import { fetchUploadProductImage } from "./Constants/fetchUploadProductImage";
import { fetchGetMyRestaurants } from "./Services/fetchGetMyRestaurants";
import { fetchEditMyRestaurant } from "./Services/fetchEditMyRestaurant";
import { fetchCreatePreference } from "./Services/fetchCreatePreference";
import { fetchCreateOrder } from "./Services/fetchCreateOrder";
import { fetchOrdersByRestaurant } from "./Services/fetchGetOrdersByRestaurant";
import { fetchChangeOrderStatus } from "./Services/fetchChangeOrderStatus";
import { fetchGetOrdersForCourier } from "./Services/fetchGetOrdersForCourier";
import { fetchCourierAssignOrder } from "./Services/fetchCourierAssignOrder";
import { fetchInactiveRestaurants } from "./Services/fetchInactiveRestaurants";
import { fetchChangeActiveRestaurant } from "./Services/fetchChangeActiveRestaurant";
import { fetchCourierMyOrders } from "./Services/fetchCourierMyOrders";
import { fetchOrdersByUser } from "./Services/fetchOrdersByUser";
import { fetchInactiveUsers } from "./Services/fetchInactiveUsers";
import { fetchActivateUser } from "./Services/fetchActivateUser";
import { fetchChangePaymentStatus } from "./Services/fetchChangePaymentStatus";
import { fetchRestaurantsByCategory } from "./Services/fetchRestaurantsByCategory";
import { fetchWeeklySalesReport } from "./Services/fetchWeeklySalesReport";
import { fetchAdminWeeklySalesReport } from "./Services/fetchAdminWeeklySalesReport";
import { fetchCourierWeeklyEarnings } from "./Services/fetchCourierWeeklyEarnings";
import { fetchAdminCourierWeeklyEarnings } from "./Services/fetchAdminCourierWeeklyEarnings";
import { fetchSetPaymentStatus } from "./Services/fetchSetPaymentStatus";

import { fetchRequestPasswordReset } from "./Services/fetchRequestPasswordReset";
import { fetchResetPassword } from "./Services/fetchResetPassword";

import { fetchSendOtp } from "./Services/Users/fetchSendOtp";
import { fetchVerifyEmail } from "./Services/Users/fetchVerifyEmail";

import { fetchLoginGoogle } from "./Services/Users/fetchLoginGoogle";
import { fetchUpdateProfile } from "./Services/Users/fetchUpdateProfile";

const useStore = create((set, get) => ({
  loading: false,
  error: null,
  success: null,
  restaurants: [],
  restaurantDetail: null,

  responseCreatePreference: {},
  loadingCreatePreference: false,
  errorCreatePreference: null,

  resetError: () => set({ error: null }),
  resetSuccess: () => set({ success: null }),
  resetRestaurants: () => set({ restaurants: [] }),
  resetRestaurantDetail: () => set({ restaurantDetail: null }),

  // --- Órdenes ---
  ordersByRestaurant: [],
  loadingGetOrdersByRestaurant: false,
  errorGetOrdersByRestaurant: null,
  nextTokenOrdersByRestaurant: null, // no se usa, lo dejamos en null
  orders: [],

  // --- Reporte semanal de ventas ---
  weeklySalesReport: null,
  loadingWeeklySalesReport: false,
  errorWeeklySalesReport: null,

  // --- Reporte semanal de ventas de TODOS los negocios (admin) ---
  adminWeeklySalesReport: null,
  loadingAdminWeeklySalesReport: false,
  errorAdminWeeklySalesReport: null,

  // --- Reporte semanal de cobro del repartidor ---
  courierWeeklyEarnings: null,
  loadingCourierWeeklyEarnings: false,
  errorCourierWeeklyEarnings: null,

  // --- Reporte semanal de cobro de TODOS los repartidores (admin) ---
  adminCourierWeeklyEarnings: null,
  loadingAdminCourierWeeklyEarnings: false,
  errorAdminCourierWeeklyEarnings: null,

  courierOrders: [],
  loadingCourierOrders: false,
  errorCourierOrders: null,

  // --- Restaurantes inactivos ---
  inactiveRestaurants: [],            // NEW
  loadingInactiveRestaurants: false,  // NEW
  errorInactiveRestaurants: null,     // NEW

  // --- Mis pedidos (repartidor) ---
  myCourierOrders: [],
  loadingMyCourierOrders: false,
  errorMyCourierOrders: null,
  myCourierOrdersCount: 0,

  // --- Pedidos del cliente (por userId) ---
  myUserOrders: [],
  myUserOrdersCount: 0,
  loadingMyUserOrders: false,
  errorMyUserOrders: null,

  // --- Usuarios inactivos (comerciante / repartidor) ---
  inactiveUsers: [],
  inactiveUsersCount: 0,
  inactiveUsersNext: null,
  loadingInactiveUsers: false,
  errorInactiveUsers: null,

  restaurantsByCategory: [],
  loadingRestaurantsByCategory: false,
  errorRestaurantsByCategory: null,

  // --- Verificación por OTP (email) ---
  otpSending: false,
  otpVerifying: false,
  otpError: null,
  otpSuccess: null,
  otpCooldownUntil: null, // timestamp para manejar "Reenviar" (opcional en UI)
  isEmailVerified: false,

  // useStore.js
  fetchDataLogin: async (body) => {
    set({ loading: true, error: null, success: null });
    try {
      const response = await fetchLogin(body);

      if (response.statusCode !== 200) {
        set({ loading: false, error: response.message || "Error en login", success: null });
        return null;
      }

      // 💾 Persistir credenciales
      try {
        if (response?.token) localStorage.setItem("token", response.token);
        if (response?.role) localStorage.setItem("role", response.role);
        if (response?.userId) localStorage.setItem("userId", response.userId);
      } catch (_) { }

      set({ loading: false, success: response });
      return response;
    } catch (error) {
      set({ error: error.message || "Error en login", loading: false, success: null });
      return null;
    }
  },

  fetchDataLoginGoogle: async (googleToken) => {
    set({ loading: true, error: null, success: null });

    try {
      const response = await fetchLoginGoogle(googleToken);

      if (response.statusCode !== 200) {
        set({
          loading: false,
          error: response.message || "Error en login con Google",
          success: null,
        });
        return null;
      }

      // 💾 Persistir igual que login normal
      try {
        if (response?.token) localStorage.setItem("token", response.token);
        if (response?.role) localStorage.setItem("role", response.role);
        if (response?.userId) localStorage.setItem("userId", response.userId);
      } catch (_) { }

      set({ loading: false, success: response });
      return response;

    } catch (error) {
      set({
        loading: false,
        error: error.message || "Error en login con Google",
        success: null,
      });
      return null;
    }
  },

  fetchDataUpdateProfile: async (profileData) => {
    set({ loading: true, error: null, success: null });
    try {
      const response = await fetchUpdateProfile(profileData);
      if (response?.statusCode === 200) {
        // Limpiar bandera de perfil incompleto
        localStorage.removeItem("profileIncomplete");
        // Actualizar phone y delivery en logindata para que HacerPedido los lea
        try {
          const ld = JSON.parse(localStorage.getItem("logindata") || "{}");
          if (ld?.data) {
            if (profileData.phone)    ld.data.phone    = profileData.phone;
            if (profileData.delivery) ld.data.delivery = profileData.delivery;
            localStorage.setItem("logindata", JSON.stringify(ld));
          }
        } catch (_) {}
        // Notifica a todos los componentes que escuchan authChange
        window.dispatchEvent(new Event("authChange"));
      }
      set({ loading: false, success: response });
      return response;
    } catch (error) {
      set({ loading: false, error: error.message || "Error al actualizar perfil", success: null });
      return null;
    }
  },

  fetchDataRegister: async (body) => {
    set({ loading: true, error: null, success: null });
    try {
      const response = await fetchRegister(body);
      set({ loading: false, success: response });
      return response;
    } catch (error) {
      set({
        error: error.message,
        loading: false,
        success: null,
      });
    }
  },

  // Restaurantes
  fetchDataRestaurantRegister: async (body) => {
    set({ loading: true, error: null, success: null });
    try {
      const res = await fetchRestaurantRegister(body);

      const ok =
        res?.statusCode === 201 ||
        res?.code === 201 ||
        res?.ok === true;

      if (!ok) {
        set({
          loading: false,
          error: res?.message || "No se pudo crear restaurante",
          success: null,
        });
        return res;
      }

      set({
        loading: false,
        success: {
          statusCode: 201,
          message: res?.message || "Restaurante creado exitosamente",
          data: res?.data ?? res,
        },
      });
      return res;
    } catch (err) {
      set({
        loading: false,
        error: err?.message || "Error creando restaurante",
        success: null,
      });
      return null;
    }
  },

  fetchDataGetRestaurants: async (limit) => {
    set({ loading: true, error: null });
    try {
      const items = await fetchRestaurants(limit);
      set({ loading: false, restaurants: items });
      return items;
    } catch (err) {
      set({ loading: false, error: err.message || "Error al obtener restaurantes" });
    }
  },

  fetchDataGetRestaurantDetail: async (restauranteId) => {
    set({ loading: true, error: null });
    try {
      const item = await fetchRestaurantDetail(restauranteId);
      set({ loading: false, restaurantDetail: item });
      return item;
    } catch (err) {
      set({ loading: false, error: err.message || "Error al obtener restaurante" });
    }
  },

  // Subir imagen de producto
  fetchDataUploadProductImage: async (formData) => {
    try {
      const response = await fetchUploadProductImage(formData);
      return response;
    } catch (error) {
      throw new Error(error.message || "Error al subir imagen");
    }
  },

  // Restaurantes del usuario autenticado
  fetchDataGetMyRestaurants: async () => {
    set({ loading: true, error: null });
    try {
      const res = await fetchGetMyRestaurants();
      // console.log("👉 Respuesta en useStore:", res);

      // ⚡ el backend manda los items en res.data.items
      const items = res.data?.items || [];

      set({ loading: false, restaurants: items });
      return items;
    } catch (err) {
      console.error("❌ Error en fetchDataGetMyRestaurants:", err);
      set({ loading: false, error: err.message });
    }
  },

  // Editar restaurante propio
  fetchDataEditMyRestaurant: async (restauranteId, body) => {
    set({ loading: true, error: null, success: null });
    try {
      const response = await fetchEditMyRestaurant(restauranteId, body);

      if (response.statusCode !== 200) {
        set({ loading: false, error: response.message || "Error al editar restaurante", success: null });
        return null;
      }

      set({ loading: false, success: response });
      return response;
    } catch (error) {
      set({ loading: false, error: error.message || "Error al editar restaurante", success: null });
      return null;
    }
  },

  createPreferencefetch: async (body) => {
    set({ loadingCreatePreference: true, errorCreatePreference: null });
    try {
      const responseCreatePreference = await fetchCreatePreference(body);
      set({ responseCreatePreference, loadingCreatePreference: false });
      return responseCreatePreference;
    } catch (error) {
      set({ errorCreatePreference: error.message, loadingCreatePreference: false });
      return null;
    }
  },

  // Crear pedido
  fetchDataCreateOrder: async (restauranteId, body) => {
    set({ loading: true, error: null, success: null });
    try {
      const response = await fetchCreateOrder(restauranteId, body);
      const status = response?.statusCode ?? response?.code ?? 500;

      // siempre apagamos loading
      set({ loading: false });

      // Para el front: SIEMPRE regresamos la respuesta, aunque sea 4xx
      if (status !== 200 && status !== 201) {
        // puedes guardar el error en el store si quieres
        set({ error: response.message || "Error al crear pedido", success: null });
      } else {
        set({ success: response, error: null });
      }

      return response;
    } catch (error) {
      set({
        loading: false,
        error: error.message || "Error al crear pedido",
        success: null,
      });
      return null;
    }
  },

  // --- Actions: Orders ---
  fetchOrdersByRestaurant: async (restauranteId) => {
    set({
      ordersLoading: true,
      ordersError: null,
      loadingGetOrdersByRestaurant: true,
      errorGetOrdersByRestaurant: null,
    });

    try {
      const resp = await fetchOrdersByRestaurant(restauranteId);

      if (resp?.statusCode === 200) {
        set({
          orders: resp.items || [],
          ordersCount: resp.count ?? (resp.items ? resp.items.length : 0),
          ordersLoading: false,
          ordersError: null,

          // 👇 sincroniza aliases
          ordersByRestaurant: resp.items || [],
          loadingGetOrdersByRestaurant: false,
          errorGetOrdersByRestaurant: null,
          nextTokenOrdersByRestaurant: null,
        });
        return resp;
      }

      set({
        ordersLoading: false,
        ordersError: resp?.message || "Error al obtener pedidos",

        // 👇 sincroniza aliases
        loadingGetOrdersByRestaurant: false,
        errorGetOrdersByRestaurant: resp?.message || "Error al obtener pedidos",
        nextTokenOrdersByRestaurant: null,
      });
      return null;
    } catch (err) {
      set({
        ordersLoading: false,
        ordersError: err?.message || "Error al obtener pedidos",

        // 👇 sincroniza aliases
        loadingGetOrdersByRestaurant: false,
        errorGetOrdersByRestaurant: err?.message || "Error al obtener pedidos",
        nextTokenOrdersByRestaurant: null,
      });
      return null;
    }
  },

  // Alias para compatibilidad con componentes que esperan este nombre
  fetchDataGetOrdersByRestaurant: async (restauranteId, _opts) => {
    return await get().fetchOrdersByRestaurant(restauranteId);
  },

  // useStore.js (solo changeStatus)
  changeStatus: async (restauranteId, orderId, action) => {
    try {
      const res = await fetchChangeOrderStatus(restauranteId, { orderId, action });

      if (res.statusCode === 200 && res.order?.orderId) {
        set((state) => ({
          orders: state.orders.map((o) =>
            o.orderId === res.order.orderId ? { ...o, ...res.order } : o
          ),
          // sincroniza alias si los usas en UI
          ordersByRestaurant: state.ordersByRestaurant.map((o) =>
            o.orderId === res.order.orderId ? { ...o, ...res.order } : o
          ),
        }));
      }

      return res; // {statusCode, message, order}
    } catch (err) {
      console.error("❌ Error en changeStatus:", err);
      throw err;
    }
  },

  // date (opcional, "YYYY-MM-DD"): semana que contiene esa fecha; si no se pasa, semana actual
  fetchDataWeeklySalesReport: async (restauranteId, date) => {
    set({ loadingWeeklySalesReport: true, errorWeeklySalesReport: null });
    try {
      const res = await fetchWeeklySalesReport(restauranteId, date);

      if (res?.statusCode === 200) {
        set({
          weeklySalesReport: res,
          loadingWeeklySalesReport: false,
          errorWeeklySalesReport: null,
        });
        return res;
      }

      set({
        weeklySalesReport: null,
        loadingWeeklySalesReport: false,
        errorWeeklySalesReport: res?.message || "Error al obtener el reporte semanal",
      });
      return null;
    } catch (err) {
      set({
        weeklySalesReport: null,
        loadingWeeklySalesReport: false,
        errorWeeklySalesReport: err?.message || "Error al obtener el reporte semanal",
      });
      return null;
    }
  },

  // date (opcional, "YYYY-MM-DD"): semana que contiene esa fecha; si no se pasa, semana actual
  fetchDataAdminWeeklySalesReport: async (date) => {
    set({ loadingAdminWeeklySalesReport: true, errorAdminWeeklySalesReport: null });
    try {
      const res = await fetchAdminWeeklySalesReport(date);

      if (res?.statusCode === 200) {
        set({
          adminWeeklySalesReport: res,
          loadingAdminWeeklySalesReport: false,
          errorAdminWeeklySalesReport: null,
        });
        return res;
      }

      set({
        adminWeeklySalesReport: null,
        loadingAdminWeeklySalesReport: false,
        errorAdminWeeklySalesReport: res?.message || "Error al obtener el reporte de negocios",
      });
      return null;
    } catch (err) {
      set({
        adminWeeklySalesReport: null,
        loadingAdminWeeklySalesReport: false,
        errorAdminWeeklySalesReport: err?.message || "Error al obtener el reporte de negocios",
      });
      return null;
    }
  },

  // date (opcional, "YYYY-MM-DD"): semana que contiene esa fecha; si no se pasa, semana actual
  fetchDataCourierWeeklyEarnings: async (date) => {
    set({ loadingCourierWeeklyEarnings: true, errorCourierWeeklyEarnings: null });
    try {
      const res = await fetchCourierWeeklyEarnings(date);

      if (res?.statusCode === 200) {
        set({
          courierWeeklyEarnings: res,
          loadingCourierWeeklyEarnings: false,
          errorCourierWeeklyEarnings: null,
        });
        return res;
      }

      set({
        courierWeeklyEarnings: null,
        loadingCourierWeeklyEarnings: false,
        errorCourierWeeklyEarnings: res?.message || "Error al obtener el reporte de cobro",
      });
      return null;
    } catch (err) {
      set({
        courierWeeklyEarnings: null,
        loadingCourierWeeklyEarnings: false,
        errorCourierWeeklyEarnings: err?.message || "Error al obtener el reporte de cobro",
      });
      return null;
    }
  },

  // date (opcional, "YYYY-MM-DD"): semana que contiene esa fecha; si no se pasa, semana actual
  fetchDataAdminCourierWeeklyEarnings: async (date) => {
    set({ loadingAdminCourierWeeklyEarnings: true, errorAdminCourierWeeklyEarnings: null });
    try {
      const res = await fetchAdminCourierWeeklyEarnings(date);

      if (res?.statusCode === 200) {
        set({
          adminCourierWeeklyEarnings: res,
          loadingAdminCourierWeeklyEarnings: false,
          errorAdminCourierWeeklyEarnings: null,
        });
        return res;
      }

      set({
        adminCourierWeeklyEarnings: null,
        loadingAdminCourierWeeklyEarnings: false,
        errorAdminCourierWeeklyEarnings: res?.message || "Error al obtener el reporte de repartidores",
      });
      return null;
    } catch (err) {
      set({
        adminCourierWeeklyEarnings: null,
        loadingAdminCourierWeeklyEarnings: false,
        errorAdminCourierWeeklyEarnings: err?.message || "Error al obtener el reporte de repartidores",
      });
      return null;
    }
  },

  // { tipo: "negocio"|"repartidor"|"repartidorDebtAdmin", entidadId, pagado, pagadoAt, date }
  setWeeklyPaymentStatus: async (params) => {
    try {
      return await fetchSetPaymentStatus(params);
    } catch (err) {
      return { statusCode: 500, message: err?.message || "Error al actualizar el estado de pago" };
    }
  },

  fetchDataGetOrdersForCourier: async () => {
    set({ loadingCourierOrders: true, errorCourierOrders: null });
    try {
      const res = await fetchGetOrdersForCourier();

      // Normaliza de forma robusta
      const items =
        res?.body?.items ??
        res?.items ??
        res?.data?.items ??
        [];

      set({
        courierOrders: items,
        loadingCourierOrders: false,
        errorCourierOrders: null,
      });

      return res;
    } catch (err) {
      set({
        loadingCourierOrders: false,
        errorCourierOrders: err?.message || "Error al obtener pedidos del repartidor",
      });
      return null;
    }
  },

  courierAssignOrder: async (orderId) => {
    const res = await fetchCourierAssignOrder(orderId);
    if (res.statusCode === 200) {
      // Opcional: actualiza lista en memoria
      const updated = res.body?.order || res.order;
      if (updated) {
        set((state) => ({
          courierOrders: state.courierOrders.map(o => o.orderId === updated.orderId ? { ...o, ...updated } : o),
        }));
      }
    }
    return res;
  },

  fetchDataInactiveRestaurants: async () => {
    set({ loadingInactiveRestaurants: true, errorInactiveRestaurants: null });
    try {
      const res = await fetchInactiveRestaurants(); // ahora lanza error si no es 200

      const body = res?.body ?? {};
      const items = Array.isArray(body?.restaurants) ? body.restaurants : [];

      if (!Array.isArray(body?.restaurants)) {
        // Fuerza ver el problema en la UI si el backend no respondió lo esperado
        throw new Error("Respuesta inesperada del servidor (sin 'restaurants').");
      }

      set({
        inactiveRestaurants: items,
        inactiveRestaurantsCount: body?.count ?? items.length,
        loadingInactiveRestaurants: false,
        errorInactiveRestaurants: null,
      });

      return items;
    } catch (err) {
      console.error("fetchDataInactiveRestaurants error:", err);
      set({
        loadingInactiveRestaurants: false,
        errorInactiveRestaurants: err?.message || "Error al obtener restaurantes inactivos",
      });
      return null;
    }
  },

  activateRestaurant: async (restauranteId) => {
    try {
      const res = await fetchChangeActiveRestaurant(restauranteId);

      if (res.statusCode === 200) {
        // quita el restaurante activado de la tabla de inactivos
        set((state) => ({
          inactiveRestaurants: (state.inactiveRestaurants || []).filter(
            (r) => r.restauranteId !== restauranteId
          ),
        }));
      }
      return res; // { statusCode, body: { message, restaurant? } }
    } catch (err) {
      console.error("❌ Error en activateRestaurant:", err);
      throw err;
    }
  },

  fetchDataCourierMyOrders: async (opts = {}) => {
    set({ loadingMyCourierOrders: true, errorMyCourierOrders: null });
    try {
      const res = await fetchCourierMyOrders(opts); // GET /courier/my-orders[?userId=...]

      const items = Array.isArray(res?.items) ? res.items : [];
      const count = Number.isFinite(res?.count) ? res.count : items.length;

      set({
        myCourierOrders: items,
        myCourierOrdersCount: count,
        loadingMyCourierOrders: false,
        errorMyCourierOrders: null,
      });

      return { items, count };
    } catch (err) {
      set({
        loadingMyCourierOrders: false,
        errorMyCourierOrders: err?.message || "Error al obtener mis pedidos",
      });
      return null;
    }
  },

  fetchDataOrdersByUser: async (userIdArg) => {
    const fallbackUserId = (() => {
      try { return localStorage.getItem("userId") || ""; } catch { return ""; }
    })();
    const userId = userIdArg || fallbackUserId;

    set({ loadingMyUserOrders: true, errorMyUserOrders: null });
    try {
      const res = await fetchOrdersByUser(userId);
      const items = Array.isArray(res?.items) ? res.items : [];
      const count = Number.isFinite(res?.count) ? res.count : items.length;

      items.sort((a, b) => String(b.createdAt || "").localeCompare(String(a.createdAt || "")));

      set({
        myUserOrders: items,
        myUserOrdersCount: count,
        loadingMyUserOrders: false,
        errorMyUserOrders: null,
      });

      return { items, count };
    } catch (err) {
      console.error("❌ useStore.fetchDataOrdersByUser error:", err);
      set({
        loadingMyUserOrders: false,
        errorMyUserOrders: err?.message || "Error al obtener pedidos del usuario",
      });
      return null;
    }
  },

  fetchDataInactiveUsers: async () => {
    set({ loadingInactiveUsers: true, errorInactiveUsers: null });
    try {
      const res = await fetchInactiveUsers();
      if (res?.statusCode === 200) {
        set({
          inactiveUsers: res.items || [],
          inactiveUsersCount: Number.isFinite(res.count) ? res.count : (res.items?.length || 0),
          loadingInactiveUsers: false,
          errorInactiveUsers: null,
        });
        return res;
      }
      set({
        loadingInactiveUsers: false,
        errorInactiveUsers: res?.message || "Error al obtener usuarios inactivos",
      });
      return null;
    } catch (err) {
      set({
        loadingInactiveUsers: false,
        errorInactiveUsers: err?.message || "Error al obtener usuarios inactivos",
      });
      return null;
    }
  },

  activateUser: async (userId) => {
    try {
      const res = await fetchActivateUser(userId);
      if (res.statusCode === 200) {
        set((state) => ({
          inactiveUsers: (state.inactiveUsers || []).filter(
            (u) => u.userId !== userId
          ),
          inactiveUsersCount: Math.max((state.inactiveUsersCount || 1) - 1, 0),
        }));
      }
      return res;
    } catch (err) {
      console.error("❌ Error en activateUser:", err);
      throw err;
    }
  },

  changePaymentStatus: async (restauranteId, orderId, action) => {
    try {
      const res = await fetchChangePaymentStatus(restauranteId, { orderId, action });

      if (res.statusCode === 200 && res.order?.orderId) {
        set((state) => ({
          orders: state.orders.map((o) =>
            o.orderId === res.order.orderId ? { ...o, ...res.order } : o
          ),
          // sincroniza también con las órdenes por restaurante
          ordersByRestaurant: state.ordersByRestaurant.map((o) =>
            o.orderId === res.order.orderId ? { ...o, ...res.order } : o
          ),
          // si manejas pedidos del repartidor
          myCourierOrders: state.myCourierOrders.map((o) =>
            o.orderId === res.order.orderId ? { ...o, ...res.order } : o
          ),
          // si manejas pedidos del cliente
          myUserOrders: state.myUserOrders.map((o) =>
            o.orderId === res.order.orderId ? { ...o, ...res.order } : o
          ),
        }));
      }

      return res; // { statusCode, message, order }
    } catch (err) {
      console.error("❌ Error en changePaymentStatus:", err);
      throw err;
    }
  },

  fetchDataRestaurantsByCategory: async (categoriaPrincipal) => {
    set({ loadingRestaurantsByCategory: true, errorRestaurantsByCategory: null });
    try {
      const items = await fetchRestaurantsByCategory(categoriaPrincipal);
      set({
        loadingRestaurantsByCategory: false,
        restaurantsByCategory: items,
        errorRestaurantsByCategory: null,
      });
      return items;
    } catch (err) {
      set({
        loadingRestaurantsByCategory: false,
        errorRestaurantsByCategory: err?.message || "Error al obtener restaurantes por categoría",
      });
      return null;
    }
  },

  // --- Recuperación de contraseña ---
  fetchDataRequestPasswordReset: async (email) => {
    set({ loading: true, error: null, success: null });
    try {
      const response = await fetchRequestPasswordReset({ email });

      if (response.statusCode !== 200) {
        set({
          loading: false,
          error: response.message || "Error al solicitar recuperación",
          success: null,
        });
        return null;
      }

      set({
        loading: false,
        success: {
          statusCode: 200,
          message: response.message || "Correo de recuperación enviado ✅",
        },
      });
      return response;
    } catch (error) {
      set({
        loading: false,
        error: error.message || "Error en recuperación de contraseña",
        success: null,
      });
      return null;
    }
  },

  fetchDataResetPassword: async (token, newPassword) => {
    set({ loading: true, error: null, success: null });
    try {
      const response = await fetchResetPassword({ token, newPassword });

      if (response.statusCode !== 200) {
        set({
          loading: false,
          error: response.message || "Error al restablecer contraseña",
          success: null,
        });
        return null;
      }

      set({
        loading: false,
        success: {
          statusCode: 200,
          message: response.message || "Contraseña actualizada correctamente 🎉",
        },
      });
      return response;
    } catch (error) {
      set({
        loading: false,
        error: error.message || "Error al restablecer contraseña",
        success: null,
      });
      return null;
    }
  },

  fetchDataSendOtp: async (email) => {
    set({ otpSending: true, otpError: null, otpSuccess: null });
    try {
      const res = await fetchSendOtp({ email });

      // éxito (200)
      set({
        otpSending: false,
        otpSuccess: res?.message || "Código enviado. Revisa tu correo 📩",
        otpError: null,
        // si quieres bloquear el botón de reenviar por ~30s:
        otpCooldownUntil: Date.now() + 30 * 1000, // puedes ajustar si tu backend usa otro cooldown
      });
      return res;
    } catch (err) {
      // Si el backend devuelve 429 con "Espera XXs", intentamos extraerlo
      let cooldownMs = null;
      const m = /(\d+)\s*s/.exec(err?.message || "");
      if (m && Number.isFinite(+m[1])) cooldownMs = +m[1] * 1000;

      set({
        otpSending: false,
        otpError: err?.message || "Error al enviar el código",
        otpSuccess: null,
        otpCooldownUntil: cooldownMs ? Date.now() + cooldownMs : null,
      });
      return null;
    }
  },

  fetchDataVerifyEmail: async ({ email, otp }) => {
    set({ otpVerifying: true, otpError: null, otpSuccess: null });
    try {
      const res = await fetchVerifyEmail({ email, otp });

      set({
        otpVerifying: false,
        otpSuccess: res?.message || "Correo verificado correctamente ✅",
        otpError: null,
        isEmailVerified: true,
      });

      // opcional: persistir una marca local
      try { localStorage.setItem("isVerified", "true"); } catch (_) { }

      return res;
    } catch (err) {
      set({
        otpVerifying: false,
        otpError: err?.message || "No se pudo verificar el correo",
        otpSuccess: null,
      });
      return null;
    }
  },

}));

export default useStore;
